module.exports = __webpack_public_path__ + "img/hotel5.5653f508.png";